import { ToolDefinition } from '../types';

const getCurrentDateTool: ToolDefinition = {
  name: 'get_current_date',
  description: 'Get current date/time. Use for time-based queries (e.g., "last 3 months", "created less than X days ago"). Returns ISO 8601 date string.',
  input_schema: {
    type: 'object',
    properties: {},
    required: [],
  },
};

/**
 * Execute the get_current_date tool
 */
export async function executeGetCurrentDate(): Promise<{ currentDate: string; timestamp: number } | { error: string }> {
  try {
    const now = new Date();
    return {
      currentDate: now.toISOString(),
      timestamp: now.getTime(),
    };
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default getCurrentDateTool;
